function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#506350",
  d: "M10.246 20h-.5l-.098-.04c-.287-.126-.529-.336-.696-.6l-1.88-2.654c-1.136-1.6-2.27-3.2-3.4-4.8C2.948 10.87 2.51 9.66 2.4 8.4c-.171-1.588.167-3.189.967-4.572.8-1.383 2.019-2.475 3.48-3.118 2.867-1.242 5.66-.85 8.079 1.134 1.498 1.214 2.451 2.976 2.646 4.894.239 1.904-.262 3.829-1.4 5.374l-5.103 7.2c-.17.289-.43.516-.737.65l-.086.038zM10 18.912c.069-.069.13-.145.182-.226 1.7-2.4 3.4-4.8 5.102-7.2.976-1.327 1.406-2.98 1.2-4.614-.162-1.638-.97-3.145-2.246-4.186C12.124.952 9.784.624 7.282 1.708c-1.25.552-2.294 1.488-2.977 2.672-.683 1.185-.971 2.557-.823 3.916.092 1.069.462 2.095 1.074 2.976 1.125 1.6 2.259 3.2 3.4 4.8.63.885 1.257 1.772 1.884 2.66.046.066.1.127.16.18zm-.02-8.358h-.028c-.764-.02-1.489-.337-2.022-.884-.534-.546-.834-1.279-.836-2.042.009-.772.325-1.508.876-2.047.55-.54 1.294-.84 2.066-.833.763.018 1.489.333 2.024.877.534.545.836 1.276.84 2.039-.007.77-.318 1.505-.865 2.046-.547.541-1.286.845-2.055.844zm.02-4.72c-.48 0-.94.189-1.282.526-.344.335-.54.794-.544 1.274 0 .992.79 1.803 1.782 1.83.486.006.955-.181 1.302-.521.348-.34.546-.805.55-1.29-.005-.991-.798-1.798-1.788-1.821H10v.002z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H20V20H0z"
})));

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.0eef325b.svg";
export { ForwardRef as ReactComponent };